module.exports = __webpack_public_path__ + "img/email_notifications.5984ab74.svg";